import React, { Component } from "react";
import PropTypes from "prop-types";
import InputRow from "./InputRow";
import Loading from "./Loading";

export default class AcademicInterest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      entryTermData: [],
      selectedEntryTerm: 0,
      programsData: [],
      selectedProgram: 0,
      majorsData: [],
      selectedMajor: 0,
      selectedUniversity: 0,
      universityData: [],
      selectedSecondUniversity: 0,
      universitySecondData: [],
      selectedSecondProgram: 0,
      programsSecondData: [],
      selectedSecondMajor: 0,
      majorSecondData: [],
      loading: true,
      description: "",
      secondDescription: "",
      selectedLevel: 0,
      levelData: [],
      selectedSecondLevel: 0,
      levelSecondData: [],
      languageData: [],
      selectedSchedule: 0,
      scheduleData: [],
      collegesData: [],
      selectedCollege: 0,
    };
    this.fetchProgram = this.fetchProgram.bind(this);
    this.fetchMajor = this.fetchMajor.bind(this);
    this.fetchMajor2 = this.fetchMajor2.bind(this);
    this.fetchMajor3 = this.fetchMajor3.bind(this);
    this.fetchMajor4 = this.fetchMajor4.bind(this);
    //this.fetchCollege2 = this.fetchCollege2.bind(this);
    this.fetchCollege = this.fetchCollege.bind(this);
    this.fetchSessionPeriod = this.fetchSessionPeriod.bind(this);
    this.handleProgramSelect = this.handleProgramSelect.bind(this);
    this.handleProgramSelect2 = this.handleProgramSelect2.bind(this);
    this.handleCollegeSelect = this.handleCollegeSelect.bind(this);
    this.handleCollegeSelect2 = this.handleCollegeSelect2.bind(this);
    this.handleSecondProgramSelect = this.handleSecondProgramSelect.bind(this);
    this.fetchLevel = this.fetchLevel.bind(this);
    this.fetchSecondLevel = this.fetchSecondLevel.bind(this);
    // this.fetchLanguage = this.fetchLanguage.bind(this);
    this.fetchUniversity = this.fetchUniversity.bind(this);
  }

  componentDidMount() {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetEntryTerm?degreeId=${this.props.selectedProgram}`
    )
      .then((res) => res.json())
      .then((res) => {
        if (this.props.selectedProgram) {
          this.setState({
            entryTermData: res,
            selectedEntryTerm: this.props.entryTerm,
          });
        }
        //this.fetchProgram();
        this.fetchCollege();
        //this.handleProgramSelect2(this.props.selectedProgram);
        // if (
        //   this.props.selectedProgram === "22" ||
        //   this.props.selectedProgram === 22
        // ) {
        if (this.props.selectedCollege) {
          this.handleCollegeSelect2(
            this.props.selectedCollege,
            this.props.selectedProgram
          );
        }
        // }
        // this.handleSecondProgramSelect(0);
        // this.fetchLevel(this.props.description);
        // this.fetchSecondLevel(this.props.secondDescription);
        // this.fetchLanguage();
        this.fetchUniversity();
        // if (this.props.selectedUniversity) {
        this.fetchSchedule();
        // }
      })
      .catch((err) => console.log(err));
  }

  fetchSessionPeriod(val) {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetEntryTerm?degreeId=${val}`
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          entryTermData: res,
          selectedEntryTerm: "",
        });
      });
  }

  fetchUniversity() {
    var university = fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetCampus`
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({ universityData: res });
        if (res.length) {
          this.setState({
            selectedUniversity: this.props.selectedUniversity,
            loading: false,
          });
          return "";
        }
      })
      .catch((err) => console.log(err));
    return university;
  }

  fetchLevel(val) {
    var level = fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetLevels?programOfStudy=${val}`
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({ levelData: res });
        if (res.length) {
          this.setState({ selectedLevel: this.props.selectedLevel });
          return "";
        }
      })
      .catch((err) => console.log(err));
    return level;
  }

  fetchSecondLevel(val) {
    var secondLevel = fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetLevels?programOfStudy=${val}`
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({ levelSecondData: res });
        if (res.length) {
          this.setState({
            selectedSecondLevel: this.props.selectedSecondLevel,
          });
          return "";
        }
      })
      .catch((err) => console.log(err));
    return secondLevel;
  }

  // fetchLanguage() {
  //   var lang = fetch(
  //     `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetPopulation`
  //   )
  //     .then((res) => res.json())
  //     .then((res) => {
  //       this.setState({ languageData: res });
  //       if (res.length) {
  //         this.setState({ selectedSchedule: this.props.selectedSchedule });
  //         return "";
  //       }
  //     })
  //     .catch((err) => console.log(err));
  //   return lang;
  // }

  fetchProgram() {
    var program = fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicInterest/Getprogram`
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({ programsData: res });
        if (res.length) {
          this.setState({ selectedProgram: this.props.selectedProgram });
          return "";
        }
      })
      .catch((err) => console.log(err));
    return program;
  }

  fetchSchedule() {
    fetch(`${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetSchedule`)
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          scheduleData: res,
          selectedSchedule: this.props.selectedSchedule,
        });
      })
      .catch((err) => console.log(err));
  }

  // fetchSchedule2(val) {
  //   fetch(
  //     `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetSchedule`
  //   )
  //     .then((res) => res.json())
  //     .then((res) => {
  //       this.setState({
  //         scheduleData: res,
  //         selectedSchedule: this.props.selectedSchedule,
  //       });
  //     })
  //     .catch((err) => console.log(err));
  // }

  fetchMajor(collegeId, programId) {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetMajors?degreeId=${programId}&collegeId=${collegeId}&populationId=1`
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({ majorsData: res });
        if (res.length) {
          if (parseInt(programId) === parseInt(this.props.selectedProgram)) {
            let setVal = "";
            res.forEach((element) => {
              if (element.value === this.props.description) {
                setVal = element.Id;
              }
            });
            this.setState({
              selectedMajor: "",
              description: this.props.description,
              loading: false,
              selectedLevel: this.props.selectedLevel,
            });
            this.props.collectState("AI", {
              selectedEntryTerm: this.state.selectedEntryTerm,
              selectedProgram: programId,
              selectedMajor: "",
              description: this.state.description,
              selectedUniversity: this.state.selectedUniversity,
              selectedSecondUniversity: this.state.selectedSecondUniversity,
              selectedSecondProgram: this.state.selectedSecondProgram,
              selectedSecondMajor: this.state.selectedSecondMajor,
              secondDescription: this.state.secondDescription,
              selectedLevel: this.state.selectedLevel,
              selectedSecondLevel: this.state.selectedSecondLevel,
              selectedSchedule: this.state.selectedSchedule,
              selectedCollege: this.state.selectedCollege,
            });
          } else {
            this.setState({
              selectedMajor: "",
              description: "",
              loading: false,
              selectedLevel: this.props.selectedLevel,
            });
            this.props.collectState("AI", {
              selectedEntryTerm: this.state.selectedEntryTerm,
              selectedProgram: programId,
              selectedMajor: "",
              description: "",
              selectedUniversity: this.state.selectedUniversity,
              selectedSecondUniversity: this.state.selectedSecondUniversity,
              selectedSecondProgram: this.state.selectedSecondProgram,
              selectedSecondMajor: this.state.selectedSecondMajor,
              secondDescription: this.state.secondDescription,
              selectedLevel: this.state.selectedLevel,
              selectedSecondLevel: this.state.selectedSecondLevel,
              selectedSchedule: this.state.selectedSchedule,
              selectedCollege: this.state.selectedCollege,
            });
          }
        } else {
          this.setState({
            selectedMajor: "",
            description: "",
            loading: false,
            selectedLevel: this.props.selectedLevel,
          });
          this.props.collectState("AI", {
            selectedEntryTerm: this.state.selectedEntryTerm,
            selectedProgram: programId,
            selectedMajor: "",
            description: "",
            selectedUniversity: this.state.selectedUniversity,
            selectedSecondUniversity: this.state.selectedSecondUniversity,
            selectedSecondProgram: this.state.selectedSecondProgram,
            selectedSecondMajor: this.state.selectedSecondMajor,
            secondDescription: this.state.secondDescription,
            selectedLevel: this.state.selectedLevel,
            selectedSecondLevel: this.state.selectedSecondLevel,
            selectedSchedule: this.state.selectedSchedule,
            selectedCollege: this.state.selectedCollege,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  fetchMajor2(collegeId, programId) {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetMajors?degreeId=${programId}&collegeId=${collegeId}&populationId=1`
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({ majorsData: res });
        if (res.length) {
          if (parseInt(programId) === parseInt(this.props.selectedProgram)) {
            let setVal = "";
            res.forEach((element) => {
              if (element.value === this.props.description) {
                setVal = element.Id;
              }
            });
            this.setState({
              selectedProgram: programId,
              selectedMajor: this.props.selectedMajor,
              description: this.props.description,
              loading: false,
              selectedLevel: this.props.selectedLevel,
            });
            this.props.collectState("AI", {
              selectedEntryTerm: this.state.selectedEntryTerm,
              selectedProgram: programId,
              selectedMajor: this.props.selectedMajor,
              description: this.props.description,
              selectedUniversity: this.props.selectedUniversity,
              selectedSecondUniversity: this.props.selectedSecondUniversity,
              selectedSecondProgram: this.props.selectedSecondProgram,
              selectedSecondMajor: this.props.selectedSecondMajor,
              secondDescription: this.props.secondDescription,
              selectedLevel: this.props.selectedLevel,
              selectedSecondLevel: this.props.selectedSecondLevel,
              selectedSchedule: this.props.selectedSchedule,
              selectedCollege: this.props.selectedCollege,
            });
          } else {
            this.setState({
              selectedProgram: programId,
              selectedMajor: this.props.selectedMajor,
              description: this.props.description,
              loading: false,
              selectedLevel: this.props.selectedLevel,
            });
            this.props.collectState("AI", {
              selectedEntryTerm: this.state.selectedEntryTerm,
              selectedProgram: programId,
              selectedMajor: this.props.selectedMajor,
              description: this.props.description,
              selectedUniversity: this.props.selectedUniversity,
              selectedSecondUniversity: this.props.selectedSecondUniversity,
              selectedSecondProgram: this.props.selectedSecondProgram,
              selectedSecondMajor: this.props.selectedSecondMajor,
              secondDescription: this.props.secondDescription,
              selectedLevel: this.props.selectedLevel,
              selectedSecondLevel: this.props.selectedSecondLevel,
              selectedSchedule: this.props.selectedSchedule,
              selectedCollege: this.props.selectedCollege,
            });
          }
        } else {
          this.setState({
            selectedProgram: programId,
            selectedMajor: this.props.selectedMajor,
            description: this.props.description,
            loading: false,
            selectedLevel: this.props.selectedLevel,
          });
          this.props.collectState("AI", {
            selectedEntryTerm: this.state.selectedEntryTerm,
            selectedProgram: programId,
            selectedMajor: this.props.selectedMajor,
            description: this.props.description,
            selectedUniversity: this.props.selectedUniversity,
            selectedSecondUniversity: this.props.selectedSecondUniversity,
            selectedSecondProgram: this.props.selectedSecondProgram,
            selectedSecondMajor: this.props.selectedSecondMajor,
            secondDescription: this.props.secondDescription,
            selectedLevel: this.props.selectedLevel,
            selectedSecondLevel: this.props.selectedSecondLevel,
            selectedSchedule: this.props.selectedSchedule,
            selectedCollege: this.props.selectedCollege,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  fetchMajor3(programId) {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetMajors?degreeId=${programId}&collegeId=-1&populationId=1`
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({ majorsData: res });
        if (res.length) {
          if (parseInt(programId) === parseInt(this.props.selectedProgram)) {
            let setVal = "";
            res.forEach((element) => {
              if (element.value === this.props.description) {
                setVal = element.Id;
              }
            });
            this.setState({
              selectedMajor: "",
              description: this.props.description,
              loading: false,
              selectedLevel: this.props.selectedLevel,
            });
            this.props.collectState("AI", {
              selectedEntryTerm: this.state.selectedEntryTerm,
              selectedProgram: programId,
              selectedMajor: "",
              description: this.state.description,
              selectedUniversity: this.state.selectedUniversity,
              selectedSecondUniversity: this.state.selectedSecondUniversity,
              selectedSecondProgram: this.state.selectedSecondProgram,
              selectedSecondMajor: this.state.selectedSecondMajor,
              secondDescription: this.state.secondDescription,
              selectedLevel: this.state.selectedLevel,
              selectedSecondLevel: this.state.selectedSecondLevel,
              selectedSchedule: this.state.selectedSchedule,
              selectedCollege: this.state.selectedCollege,
            });
          } else {
            this.setState({
              selectedMajor: "",
              description: "",
              loading: false,
              selectedLevel: this.props.selectedLevel,
            });
            this.props.collectState("AI", {
              selectedEntryTerm: this.state.selectedEntryTerm,
              selectedProgram: programId,
              selectedMajor: "",
              description: "",
              selectedUniversity: this.state.selectedUniversity,
              selectedSecondUniversity: this.state.selectedSecondUniversity,
              selectedSecondProgram: this.state.selectedSecondProgram,
              selectedSecondMajor: this.state.selectedSecondMajor,
              secondDescription: this.state.secondDescription,
              selectedLevel: this.state.selectedLevel,
              selectedSecondLevel: this.state.selectedSecondLevel,
              selectedSchedule: this.state.selectedSchedule,
              selectedCollege: this.state.selectedCollege,
            });
          }
        } else {
          this.setState({
            selectedMajor: "",
            description: "",
            loading: false,
            selectedLevel: this.props.selectedLevel,
          });
          this.props.collectState("AI", {
            selectedEntryTerm: this.state.selectedEntryTerm,
            selectedProgram: programId,
            selectedMajor: "",
            description: "",
            selectedUniversity: this.state.selectedUniversity,
            selectedSecondUniversity: this.state.selectedSecondUniversity,
            selectedSecondProgram: this.state.selectedSecondProgram,
            selectedSecondMajor: this.state.selectedSecondMajor,
            secondDescription: this.state.secondDescription,
            selectedLevel: this.state.selectedLevel,
            selectedSecondLevel: this.state.selectedSecondLevel,
            selectedSchedule: this.state.selectedSchedule,
            selectedCollege: this.state.selectedCollege,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  fetchMajor4(programId) {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetMajors?degreeId=${programId}&collegeId=-1&populationId=1`
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({ majorsData: res });
        if (res.length) {
          if (parseInt(programId) === parseInt(this.props.selectedProgram)) {
            let setVal = "";
            res.forEach((element) => {
              if (element.value === this.props.description) {
                setVal = element.Id;
              }
            });
            this.setState({
              selectedProgram: programId,
              selectedMajor: this.props.selectedMajor,
              description: this.props.description,
              loading: false,
              selectedLevel: this.props.selectedLevel,
            });
            this.props.collectState("AI", {
              selectedEntryTerm: this.state.selectedEntryTerm,
              selectedProgram: programId,
              selectedMajor: this.props.selectedMajor,
              description: this.props.description,
              selectedUniversity: this.props.selectedUniversity,
              selectedSecondUniversity: this.props.selectedSecondUniversity,
              selectedSecondProgram: this.props.selectedSecondProgram,
              selectedSecondMajor: this.props.selectedSecondMajor,
              secondDescription: this.props.secondDescription,
              selectedLevel: this.props.selectedLevel,
              selectedSecondLevel: this.props.selectedSecondLevel,
              selectedSchedule: this.props.selectedSchedule,
              selectedCollege: this.props.selectedCollege,
            });
          } else {
            this.setState({
              selectedProgram: programId,
              selectedMajor: this.props.selectedMajor,
              description: this.props.description,
              loading: false,
              selectedLevel: this.props.selectedLevel,
            });
            this.props.collectState("AI", {
              selectedEntryTerm: this.state.selectedEntryTerm,
              selectedProgram: programId,
              selectedMajor: this.props.selectedMajor,
              description: this.props.description,
              selectedUniversity: this.props.selectedUniversity,
              selectedSecondUniversity: this.props.selectedSecondUniversity,
              selectedSecondProgram: this.props.selectedSecondProgram,
              selectedSecondMajor: this.props.selectedSecondMajor,
              secondDescription: this.props.secondDescription,
              selectedLevel: this.props.selectedLevel,
              selectedSecondLevel: this.props.selectedSecondLevel,
              selectedSchedule: this.props.selectedSchedule,
              selectedCollege: this.props.selectedCollege,
            });
          }
        } else {
          this.setState({
            selectedProgram: programId,
            selectedMajor: this.props.selectedMajor,
            description: this.props.description,
            loading: false,
            selectedLevel: this.props.selectedLevel,
          });
          this.props.collectState("AI", {
            selectedEntryTerm: this.state.selectedEntryTerm,
            selectedProgram: programId,
            selectedMajor: this.props.selectedMajor,
            description: this.props.description,
            selectedUniversity: this.props.selectedUniversity,
            selectedSecondUniversity: this.props.selectedSecondUniversity,
            selectedSecondProgram: this.props.selectedSecondProgram,
            selectedSecondMajor: this.props.selectedSecondMajor,
            secondDescription: this.props.secondDescription,
            selectedLevel: this.props.selectedLevel,
            selectedSecondLevel: this.props.selectedSecondLevel,
            selectedSchedule: this.props.selectedSchedule,
            selectedCollege: this.props.selectedCollege,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  fetchCollege() {
    fetch(`${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetColleges`)
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          collegesData: res,
          selectedCollege: this.props.selectedCollege,
          selectedProgram: this.props.selectedProgram,
          loading: false,
        });
      })
      .catch((err) => console.log(err));
  }
  // fetchCollege(val) {
  //   val = val == "" ? 2000 : val;
  //   fetch(
  //     `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetColleges?degreeId=${val}`
  //   )
  //     .then((res) => res.json())
  //     .then((res) => {
  //       this.setState({
  //         collegesData: res,
  //         selectedCollege: res.length > 0 ? res[0].Id : "",
  //         selectedMajor: "",
  //         majorsData: "",
  //       });
  //       if (this.state.selectedCollege) {
  //         this.fetchMajor(
  //           this.state.selectedCollege,
  //           this.state.selectedProgram
  //         );
  //       }
  //     })
  //     .catch((err) => console.log(err));
  // }

  handleProgramSelect(e) {
    // if (e !== "22" && e !== 22) {
    //   this.setState({ selectedProgram: e }, () => {
    //     this.fetchMajor3(this.state.selectedProgram);
    //     this.fetchSessionPeriod(this.state.selectedProgram);
    //   });
    // } else {
    this.setState({ selectedProgram: e }, () => {
      this.fetchSessionPeriod(this.state.selectedProgram);
    });
    // }
  }

  handleProgramSelect2(e) {
    // if (e !== "22" && e !== 22) {
    //   this.setState({ selectedProgram: e }, () => {
    //     this.fetchMajor4(this.state.selectedProgram);
    //   });
    // } else {
    this.setState({ selectedProgram: e }, () => {
      //this.fetchCollege2(this.state.selectedProgram);
    });
  }
  // }

  handleCollegeSelect(e, val) {
    this.setState({ selectedProgram: val }, () => {
      this.fetchSessionPeriod(this.state.selectedProgram);
    });
    this.setState({ selectedCollege: e, selectedProgram: val }, () => {
      if (this.state.selectedCollege === null) {
        this.fetchMajor(1000, val);
      } else {
        this.fetchMajor(this.state.selectedCollege, val);
        this.fetchSessionPeriod(val);
      }
    });
  }

  handleCollegeSelect2(e, val) {
    this.setState({ selectedCollege: e }, () => {
      if (this.state.selectedCollege === null) {
        this.fetchMajor2(1000, val);
      } else {
        this.fetchMajor2(this.state.selectedCollege, val);
      }
    });
  }

  handleSecondProgramSelect(e) {
    //console.log(e);
    const { selectedEntryTerm } = this.state;
    this.setState({ selectedSecondProgram: e });
    // fetch data of majors and set its state here
    fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetMajors?programId=${e}&populationId=1`
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({ majorSecondData: res });
        if (res.length) {
          if (parseInt(e) === parseInt(this.props.selectedSecondProgram)) {
            let setVal = "";
            res.forEach((element) => {
              if (element.value === this.props.secondDescription) {
                setVal = element.Id;
              }
            });
            this.setState({
              selectedSecondMajor: setVal,
              secondDescription: this.props.secondDescription,
              loading: false,
              selectedSecondLevel: this.props.selectedSecondLevel,
            });
            this.props.collectState("AI", {
              selectedEntryTerm: selectedEntryTerm,
              selectedProgram: this.props.selectedProgram,
              selectedMajor: this.state.selectedMajor,
              description: this.props.description,
              selectedUniversity: this.props.selectedUniversity,
              selectedSecondUniversity: this.props.selectedSecondUniversity,
              selectedSecondProgram: e,
              selectedSecondMajor: setVal,
              secondDescription: this.props.secondDescription,
              selectedLevel: this.props.selectedLevel,
              selectedSecondLevel: this.props.selectedSecondLevel,
              selectedSchedule: this.props.selectedSchedule,
              selectedCollege: this.props.selectedCollege,
            });
          } else {
            this.setState({
              selectedSecondMajor: "",
              secondDescription: "",
              loading: false,
              selectedSecondLevel: this.props.selectedSecondLevel,
            });
            this.props.collectState("AI", {
              selectedEntryTerm: selectedEntryTerm,
              selectedProgram: e,
              selectedMajor: this.props.selectedMajor,
              description: this.props.description,
              selectedUniversity: this.props.selectedUniversity,
              selectedSecondUniversity: this.props.selectedSecondUniversity,
              selectedSecondProgram: this.props.selectedSecondProgram,
              selectedSecondMajor: "",
              secondDescription: "",
              selectedLevel: this.props.selectedLevel,
              selectedSecondLevel: this.props.selectedSecondLevel,
              selectedSchedule: this.props.selectedSchedule,
              selectedCollege: this.props.selectedCollege,
            });
          }
        } else {
          this.setState({
            selectedSecondMajor: "",
            secondDescription: "",
            loading: false,
            selectedSecondLevel: this.props.selectedSecondLevel,
          });
          this.props.collectState("AI", {
            selectedEntryTerm: selectedEntryTerm,
            selectedProgram: e,
            selectedMajor: this.props.selectedMajor,
            description: this.props.description,
            selectedUniversity: this.props.selectedUniversity,
            selectedSecondUniversity: this.props.selectedSecondUniversity,
            selectedSecondProgram: this.props.selectedSecondProgram,
            selectedSecondMajor: "",
            secondDescription: "",
            selectedLevel: this.props.selectedLevel,
            selectedSecondLevel: this.props.selectedSecondLevel,
            selectedSchedule: this.props.selectedSchedule,
            selectedCollege: this.props.selectedCollege,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    const validationError = this.props.error;
    const {
      majorsData,
      selectedProgram,
      selectedMajor,
      selectedEntryTerm,
      selectedUniversity,
      selectedSchedule,
      selectedCollege,
      loading,
      error,
      entryTermData,
      programsData,
      description,
      universityData,
      selectedSecondUniversity,
      universitySecondData,
      selectedSecondProgram,
      selectedSecondMajor,
      majorSecondData,
      secondDescription,
      selectedLevel,
      levelData,
      selectedSecondLevel,
      levelSecondData,
      languageData,
      scheduleData,
      collegesData,
    } = this.state;

    if (loading) {
      return <Loading />;
    }

    return (
      <div id="height">
        <div>
          {error && <p style={{ color: "red" }}>{error}</p>}

          <div>
            {/* <InputRow
              name="select"
              rowName="Program"
              value={selectedProgram}
              required="*"
              hover="Please select the program you are interested in. يرجى تحديد البرنامج الذي ترغب فيه."
              errMsg={
                validationError.selectedProgram
                  ? validationError.selectedProgram
                  : ""
              }
              data={programsData}
              onChange={(e) => {
                this.handleProgramSelect(e);
                this.props.collectState("AI", {
                  selectedEntryTerm: selectedEntryTerm,
                  selectedProgram: e,
                  selectedMajor: selectedMajor,
                  description: description,
                  seconddescription: secondDescription,
                  selectedUniversity: selectedUniversity,
                  selectedSecondUniversity: 2,
                  selectedSecondProgram: selectedSecondProgram,
                  selectedSecondMajor: selectedSecondMajor,
                  secondDescription: secondDescription,
                  selectedLevel: selectedLevel,
                  selectedSecondLevel: selectedSecondLevel,
                  selectedSchedule: selectedSchedule,
                  selectedCollege: selectedCollege,
                });
              }}
            /> */}

            {/* {(selectedProgram === 22 || selectedProgram === "22") && ( */}
            <InputRow
              name="select"
              rowName="Program"
              value={selectedCollege}
              required="*"
              hover="Please select the program you are interested in. يرجى تحديد البرنامج الذي ترغب فيه."
              errMsg={
                validationError.selectedCollege
                  ? validationError.selectedCollege
                  : ""
              }
              data={collegesData}
              onChange={(e) => {
                this.setState(
                  {
                    selectedProgram:
                      e === "14" || e === 14
                        ? 23
                        : e === "16" || e === 16
                        ? 22
                        : "",
                  },
                  () => {
                    this.handleCollegeSelect(e, this.state.selectedProgram);
                  }
                );
                this.props.collectState("AI", {
                  selectedEntryTerm: selectedEntryTerm,
                  selectedProgram:
                    selectedCollege === "14" || selectedCollege === 14
                      ? 23
                      : selectedCollege === "16" || selectedCollege === 16
                      ? 22
                      : "",
                  selectedMajor: selectedMajor,
                  description: description,
                  seconddescription: secondDescription,
                  selectedUniversity: selectedUniversity,
                  selectedSecondUniversity: 2,
                  selectedSecondProgram: selectedSecondProgram,
                  selectedSecondMajor: selectedSecondMajor,
                  secondDescription: secondDescription,
                  selectedLevel: selectedLevel,
                  selectedSecondLevel: selectedSecondLevel,
                  selectedSchedule: selectedSchedule,
                  selectedCollege: e,
                });
              }}
            />
            {/* )} */}

            <InputRow
              name="select"
              rowName="Major"
              value={selectedMajor}
              required="*"
              hover="Please select the major you are interrested to apply . يرجى اختيار التخصص الذي ترغب في التقديم عليه"
              errMsg={
                validationError.selectedMajor
                  ? validationError.selectedMajor
                  : ""
              }
              data={majorsData}
              onChange={(e) => {
                const descriptions = majorsData.filter(
                  (element) => element.Id === parseInt(e)
                );
                this.props.collectState("AI", {
                  selectedEntryTerm: selectedEntryTerm,
                  selectedProgram: selectedProgram,
                  selectedMajor: e,
                  description:
                    descriptions && descriptions.length > 0
                      ? descriptions[0].value
                      : "",
                  selectedUniversity: selectedUniversity,
                  selectedSecondUniversity: 2,
                  selectedSecondProgram: selectedSecondProgram,
                  selectedSecondMajor: selectedSecondMajor,
                  secondDescription: secondDescription,
                  selectedLevel: "",
                  selectedSecondLevel: selectedSecondLevel,
                  selectedSchedule: selectedSchedule,
                  selectedCollege: selectedCollege,
                });
                this.setState({
                  selectedMajor: e,
                  description:
                    descriptions && descriptions.length > 0
                      ? descriptions[0].value
                      : "",
                  selectedLevel: "",
                });
                if (descriptions.length > 0) {
                  this.fetchLevel(descriptions[0].value);
                }
              }}
            />

            <InputRow
              name="select"
              rowName="Entry Term"
              value={selectedEntryTerm}
              required="*"
              hover="Please select the term you are interested in. يرجى تحديد الفصل الدراسي الذي ترغب فيه."
              errMsg={
                validationError.selectedEntryTerm
                  ? validationError.selectedEntryTerm
                  : ""
              }
              data={entryTermData}
              onChange={(e) => {
                this.setState({ selectedEntryTerm: e });
                this.props.collectState("AI", {
                  selectedEntryTerm: e,
                  selectedProgram: selectedProgram,
                  selectedMajor: selectedMajor,
                  description: description,
                  seconddescription: secondDescription,
                  selectedUniversity: selectedUniversity,
                  selectedSecondUniversity: 2,
                  selectedSecondProgram: selectedSecondProgram,
                  selectedSecondMajor: selectedSecondMajor,
                  secondDescription: secondDescription,
                  selectedLevel: selectedLevel,
                  selectedSecondLevel: selectedSecondLevel,
                  selectedSchedule: selectedSchedule,
                  selectedCollege: selectedCollege,
                });
              }}
            />

            <InputRow
              name="select"
              rowName="Preferred Campus"
              required="*"
              value={selectedUniversity}
              hover="Please select the campus you are applying for. يرجى تحديد الجامعة التي تتقدم بالطلب عليها"
              errMsg={validationError.selectedUniversity || ""}
              data={universityData}
              onChange={(e) => {
                const selectedUniId = parseInt(e);
                const descriptions = universityData.filter(
                  (element) => element.Id === selectedUniId
                );
                const description =
                  descriptions.length > 0 ? descriptions[0].value : "";

                this.setState({
                  selectedUniversity: e,
                  description,
                  selectedMajor: selectedMajor,
                  showIMBAWarning: selectedUniId === 421,
                });

                this.props.collectState("AI", {
                  selectedEntryTerm: selectedEntryTerm,
                  selectedProgram: selectedProgram,
                  selectedMajor: selectedMajor,
                  description,
                  selectedUniversity: e,
                  selectedSecondUniversity: 2,
                  selectedSecondProgram: selectedSecondProgram,
                  selectedSecondMajor: selectedSecondMajor,
                  secondDescription: secondDescription,
                  selectedLevel: "",
                  selectedSecondLevel: selectedSecondLevel,
                  selectedSchedule: selectedSchedule,
                  selectedCollege: selectedCollege,
                });
              }}
            />

            {this.state.showIMBAWarning && (
              <div style={{ color: "red" }}>
                {/* IMBA students are required to attend 4 courses out of the total
                16 courses on campus over the span of 5 consecutive days. */}
                <ul style={{ margin: 0, paddingLeft: "1.2em" }}>
                  <li style={{ marginBottom: "0.5em" }}>
                    iMBA students attend 3 courses (each course 5 consecutive
                    days) and a final presentation on campus
                  </li>
                  <li style={{ marginBottom: "0.5em" }}>
                    Modular DBA students attend 4 courses (each course 5
                    consecutive days) and a dissertation defense on campus
                  </li>
                </ul>
              </div>
            )}

            {selectedUniversity === 421 && (
              <div style={{ color: "red" }}>
                {/* IMBA students are required to attend 4 courses out of the total
                16 courses on campus over the span of 5 consecutive days. */}
                <ul style={{ margin: 0, paddingLeft: "1.2em" }}>
                  <li style={{ marginBottom: "0.5em" }}>
                    iMBA students attend 3 courses (each course 5 consecutive
                    days) and a final presentation on campus
                  </li>
                  <li style={{ marginBottom: "0.5em" }}>
                    Modular DBA students attend 4 courses (each course 5
                    consecutive days) and a dissertation defense on campus
                  </li>
                </ul>
              </div>
            )}

            <InputRow
              name="select"
              rowName="Preferred Schedule"
              value={selectedSchedule}
              required="*"
              hover="Please select the schedule you are interested in. يرجى تحديد الدراسي الذي ترغب فيه."
              errMsg={
                validationError.selectedSchedule
                  ? validationError.selectedSchedule
                  : ""
              }
              data={scheduleData}
              onChange={(e) => {
                this.setState({ selectedSchedule: e });
                this.props.collectState("AI", {
                  selectedEntryTerm: selectedEntryTerm,
                  selectedProgram: selectedProgram,
                  selectedMajor: selectedMajor,
                  description: description,
                  seconddescription: secondDescription,
                  selectedUniversity: selectedUniversity,
                  selectedSecondUniversity: 2,
                  selectedSecondProgram: selectedSecondProgram,
                  selectedSecondMajor: selectedSecondMajor,
                  secondDescription: secondDescription,
                  selectedLevel: selectedLevel,
                  selectedSecondLevel: selectedSecondLevel,
                  selectedSchedule: e,
                  selectedCollege: selectedCollege,
                });
              }}
            />
          </div>
        </div>

        <button
          className="save"
          onClick={() => {
            this.props.onSave();
          }}
        >
          Next
        </button>
      </div>
    );
  }
}

AcademicInterest.propTypes = {
  onSave: PropTypes.func.isRequired,
  incompleteApplicationId: PropTypes.number.isRequired,
  selectedProgram: PropTypes.number,
  selectedUniversity: PropTypes.number,
  selectedMajor: PropTypes.number,
  selectedSchedule: PropTypes.number,
  selectedCollege: PropTypes.number,
  selectedSecondProgram: PropTypes.number,
  selectedSecondUniversity: 2,
  entryTerm: PropTypes.number,
  description: PropTypes.string,
  secondDescription: PropTypes.string,
  collectState: PropTypes.func,
  error: PropTypes.object,
};
